module.exports = __webpack_public_path__ + "img/lFwdHB.8b7069ad.svg";